module.exports = __webpack_public_path__ + "img/email.5f4d2e5a.svg";